module.exports = __webpack_public_path__ + "static/img/qbxt.b73a367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qbxt.png
// module id = SCtZ
// module chunks = 0